import { render, staticRenderFns } from "./RegistryMessages.vue?vue&type=template&id=796f26e3&scoped=true&"
import script from "./RegistryMessages.vue?vue&type=script&lang=js&"
export * from "./RegistryMessages.vue?vue&type=script&lang=js&"
import style0 from "./RegistryMessages.vue?vue&type=style&index=0&id=796f26e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796f26e3",
  null
  
)

export default component.exports